
<ngx-ui-loader fgsColor="#2142fe" text="Cargando..." ></ngx-ui-loader>

<router-outlet></router-outlet>
  <small class="estilo-dark">Copyright © <!-- -->2023<!-- --> MOPA. {{version}}</small>
